import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isUnverifiedSession } from '../utils/verification';

const ProtectedRoutes = () => {
    const { user } = useSelector((state) => state.user);
    const location = useLocation();

    // Get the full path including query parameters
    const from = location.pathname + location.search;

    if (!user) {
        return (
            <Navigate
                to="/login"
                state={{ from }}
                replace
            />
        );
    }

    // An unverified session must not reach the shop — the backend caps it to
    // the account's own record, so every request here would 403. Send it to
    // re-verification instead (#137, #145).
    if (isUnverifiedSession(user)) {
        return (
            <Navigate
                to="/reverify"
                replace
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRoutes;
